module.exports = __webpack_public_path__ + "img/DE06110.688e6cea.png";